import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from 'src/app/@core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask';
import { ProgramacaoFeriasComponent } from './ferias/ferias.component';


@NgModule({
  declarations: [
    ProgramacaoFeriasComponent,
  ],
  imports: [
    CommonModule,
    CoreModule,
    ReactiveFormsModule,
    NgxMaskModule.forChild()
  ],
  entryComponents: [
    ProgramacaoFeriasComponent,
  ]
})
export class ProgramacaoModule { }
